import { defineService } from '@nzyme/ioc/Service.js';
import { Logger } from '@nzyme/logging/Logger.js';
import { reactive } from '@nzyme/vue-utils/reactivity/reactive.js';
import { useBrowserTabStatus } from '@nzyme/vue-utils/useBrowserTabStatus.js';
import { watch } from 'vue';
export const BrowserTabService = defineService({
    name: 'BrowserTabService',
    deps: {
        logger: Logger,
    },
    setup({ logger }) {
        const status = useBrowserTabStatus();
        watch(status, tabStatus => {
            logger.info(`Browser tab status changed to ${tabStatus}`, { status: tabStatus });
        });
        return reactive({
            status,
        });
    },
});
//# sourceMappingURL=BrowserTabService.js.map